/*
 * @Description:流程管理--阶段流程设置
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  赢率: 'Win rate',
  执行: 'Execute',
  动作: 'Action',
  空任务: 'Empty task',
  审批任务: 'Approve task',
  新增流程: 'Add process',
  添加任务: 'Add task',
  编辑任务: 'Edit task',
  流程名称: 'Process name',
  对象字段: 'Object field',
  适用范围: 'Scope of application',
  阶段名称: 'Stage name',
  显示赢率: 'Display win rate',
  商机状态: 'Business opportunity status',
  结束节点: 'End node',
  节点名称: 'Node name',
  节点必做任务: 'Node mandatory task',
  条件类型: 'Condition type',
  请选择条件类型: 'Please select condition type',
  '填写/编辑对象字段': 'Fill in / edit object field',
  新增对象数据: 'Add object data',
  对象数据如需审批则完成规则为: 'Object needs approval to complete the rule is',
  审批通过后可完成该任务: 'Approval passed can complete the task',
  审批发起后可完成该任务: 'Approval initiated can complete the task',
  触发规则: 'Trigger rules',
  触发方式: 'Trigger method',
  请选择触发方式: 'Please select trigger method',
  设置节点限定处理时间: 'Set node processing time',
  请选择节点限定时间: 'Please select node processing time limit',
  通知规则: 'Notification rules',
  接收人: 'Receiver',
  标题: 'Title',
  请选择接收人: 'Please select receiver',
  请输入标题: 'Please enter title',
  标题不能超过150个字符: 'Title cannot exceed 150 characters',
  消息内容: 'content',
  节点信息: 'Node information',
  添加消息通知: 'Add message notification',
  消息接收人: 'Message receiver',
  请输入节点名称: 'Please enter node name',
  节点显示设置: 'Node display setting',
  以下是结束节点: 'Following is the end node',
  全部商机阶段: 'All business opportunity stages',
  流程发起对象: 'Process initiator',
  流程绘制: 'Flow drawing',
  流程发起字段: 'Process initiator field',
  阶段流程设置: 'Stage process settings',
  阶段节点信息: 'Stage node information',
  任务列表: 'Task list',
  消息列表: 'Message list',
  阶段流程编辑: 'Stage process edit',
  阶段流程新增: 'Add stage process',
  提交数据失败: 'Failed to submit data',
  '添加云文档/附件': 'Add cloud document/attachment',
  填写对象下字段: 'Fill in the fields under the object',
  选择的商机阶段: 'Selected business opportunity stage',
  是否支持跨阶段: 'Does it support cross-phase',
  修改字段状态失败: 'Failed to modify field status',
  获取字段列表失败: 'Failed to get field list',
  至少要选择一个阶段: 'At least one stage must be selected',
  获取全局字段列表失败: 'Failed to get global field list',
  获取对象详情数据失败: 'Failed to get object detail data',
  请为选择的所有阶段设置赢率: 'Please set the win rate for all selected stages',
  请为选择的所有阶段设置商机状态: 'Please set the business status for all selected stages',
  '取消后本次更改不生效，是否确认？': 'Canceling will invalidate this change, confirm?',
  流程阶段设置: 'Process stage settings',
  映射至烽火: 'Map to Beacon',
  映射至外部系统: 'Map to an external object',
  添加任务字段: 'Add task column'
};
